import { render } from "./LazyBaseImage.vue?vue&type=template&id=54ca2c8d&scoped=true"
import script from "./LazyBaseImage.vue?vue&type=script&lang=ts"
export * from "./LazyBaseImage.vue?vue&type=script&lang=ts"

import "./LazyBaseImage.vue?vue&type=style&index=0&id=54ca2c8d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-54ca2c8d"

export default script